import { PayloadAction } from '@reduxjs/toolkit';

export const reducers = {
  setSelectedItem(state, action: PayloadAction<any>) {
    const { item, currentStep } = action.payload;
    state[currentStep].item = item;
  },
  setActuatorFilter(state, action: PayloadAction<any>) {
    const { diffPressValue } = action.payload;
    state[2] = { ...state[2], filters: diffPressValue };
  },
  removeSelectedItems(state, action: PayloadAction<any>) {
    const { currentStep } = action.payload;
    for (let i = currentStep; i <= 5; i++) {
      state[i].item = null;
    }
  },
};
